// extracted by mini-css-extract-plugin
export var img = "styles-module__img___e6YvA";
export var mobileHeader = "styles-module__mobileHeader___FCiKN";
export var mobileRightSpacer = "styles-module__mobileRightSpacer___u45WT";